import { combineReducers } from '@reduxjs/toolkit';
import generalSlice from '../slices/general.slice';
import userSlice from '../slices/user.slice';
import operatorSlice from '../slices/operator.slice';
import investorSlice from '../slices/investor.slice';
import oldThemeSlice from '../slices/oldTheme.slice';
import themeSlice from '../slices/theme.slice';
import filesSlice from '../slices/files.slice';
import dialogsSlice from '../slices/dialogs.slice';
import fileTaggingSlice from '../slices/fileTagging.slice';
import userEntitySlice from '../slices/userEntity.slice';
import notificationSlice from '../slices/notification.slice';

const rootReducer = combineReducers({
  /* your app’s top-level reducers */
  general: generalSlice,
  user: userSlice,
  operator: operatorSlice,
  investor: investorSlice,
  oldTheme: oldThemeSlice,
  theme: themeSlice,
  files: filesSlice,
  overlays: dialogsSlice,
  fileTagging: fileTaggingSlice,
  userEntity: userEntitySlice,
  notifications: notificationSlice,
  dialogs: dialogsSlice,
});

// const rootReducer = (state, action) => {
//   if (action.type === "LOGOUT") {
//     state = undefined;
//   }

//   return appReducer(state, action);
// };

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
